import { useTheme } from '@emotion/react';
import { isFunction } from 'radash';
import { useCssMixins } from './use-css-mixins.js';

/**
 * Hook that composes CSS with type safety for use with Emotion.
 *
 * @param css - The CSS to compose.
 */ function useCss(css) {
    const theme = useTheme();
    const mixins = useCssMixins();
    return isFunction(css) ? css({
        theme,
        mixins
    }) : css;
}

export { useCss };
//# sourceMappingURL=use-css.js.map
